import axios from "axios"

// constants
import apiEndpoints from "api/utils/apiEndpoints"
import queryKeys from "api/utils/queryKeys"

// apis
import useGetApi from "../useGetApi"
import useMutateApi from "../useMutateApi"
import getUrl from "api/apiMap"

export const useGetSubmissionsHistory = (authoringId) => {
  return useGetApi(
    getUrl(`${apiEndpoints.authoring}${authoringId}/submission-history/`),
    queryKeys.submissions.list(authoringId)
  )
}

export const usePostSubmission = (authoringId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.authoring}${authoringId}/submission-history/`),
    invalidateQueries: [queryKeys.submissions.list(authoringId), queryKeys.uploadHistory],
    successMsg: "Successfully completed submission/download",
  })
}

export const useGetApprovalHistory = (authoringId) => {
  return useGetApi(
    getUrl(`${apiEndpoints.authoring}${authoringId}/approval-records/`),
    queryKeys.submissions.approvals(authoringId)
  )
}

export const usePostApprovalHistory = (authoringId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.authoring}${authoringId}/approval-records/`),
    invalidateQueries: [queryKeys.submissions.approvals(authoringId)],
    // NOTE: all study review notifications show up at the top/center of the screen
    successMsg: {
      description: "Successfully completed approval",
      placement: "top",
    },
  })
}

export const useGetPrsSubmissionsUpload = (queueId, options) => {
  return useGetApi(getUrl(apiEndpoints.submissionsUpload), [], options, {
    "queue-id": queueId,
  })
}

export const usePostPrsSubmissionsUpload = () => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(apiEndpoints.submissionsUpload),
    invalidateQueries: [],
    // successMsg: "PRS submission upload in progress"
  })
}

export const useDownloadXml = (authoringId) => {
  return useMutateApi({
    method: "post",
    apiEndpoint: getUrl(`${apiEndpoints.authoring}${authoringId}/xml-download`),
    invalidateQueries: [queryKeys.submissions.list(authoringId)],
    successMsg: "Successfully completed XML download",
  })
}

export const postPrsDocumentStatus = (authoringId, prsCredentials) => {
  let data = axios.post(getUrl(`${apiEndpoints.authoring}${authoringId}/prs-uploaded-docs/`), {
    prs_creds: prsCredentials,
  })
  return data
}
